import { toWSDateString } from "@wingspanhq/fe-component-library";
import { AccountTransaction, Person } from "@wingspanhq/wingspan-api-sdk";
import { selectorPersonDisplayName } from "../../../shared/selectors/selectorPersonDisplayName";
import { openInNewTab } from "../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../types/wsLinks";

export const disputeTransaction = (
  transaction: AccountTransaction,
  person: Person,
  userId: string
) => {
  openInNewTab(
    WS_LINKS.disputeWalletTransaction({
      userId,
      email: person.email || "",
      fullName: selectorPersonDisplayName(person),
      transactionId: transaction.id,
      transactionAmount: Number(transaction.amount),
      transactionDate: toWSDateString(transaction.effectiveAt),
      cardNumber: ""
    })
  );
};
